import { IconButton, Typography } from '@material-ui/core'
import MoreIcon from '@material-ui/icons/MoreVert'
import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'

import useStyles from './styles/ProviderRowSkeleton.styles'

interface ProviderRowSkeletonProps {
  isSmallScreen: boolean
}

const ProviderRowSkeleton: React.FC<ProviderRowSkeletonProps> = ({
  isSmallScreen
}) => {
  const classes = useStyles()

  return (
    <div className={classes.tableRowSkeleton}>
      <div>
        <Typography variant="body1">
          <Skeleton animation="wave" className={classes.skeleton} />
        </Typography>
      </div>
      {!isSmallScreen && (
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
      )}
      <div>
        <Typography variant="body1">
          <Skeleton animation="wave" className={classes.skeleton} />
        </Typography>
      </div>
      {!isSmallScreen && (
        <>
          <div>
            <Typography variant="body1">
              <Skeleton animation="wave" className={classes.skeleton} />
            </Typography>
          </div>
          <div>
            <Typography variant="body1">
              <Skeleton animation="wave" className={classes.skeleton} />
            </Typography>
          </div>
          <div>
            <Typography variant="body1">
              <Skeleton animation="wave" className={classes.skeleton} />
            </Typography>
          </div>
        </>
      )}
      <IconButton className={classes.moreIconHidden}>
        <MoreIcon />
      </IconButton>
    </div>
  )
}

export default ProviderRowSkeleton
